import React, { ReactNode } from 'react';
import { BasicModal } from '@hz-design-system/web-ui';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import useRefreshEssentialBanners from '../../../BannersApp/hooks/useRefreshEssentialBanners';
import Banners from '../../../BannersApp/components/Banners/Banners';
import { BANNER_POSITION } from '../../../BannersApp/constants/banners';

import Classes from './Gallery.scss';

type TCarouselDialogProps = {
  children: ReactNode;
  imageIndex: number;
  totalImageCount: number;
  toggleCarouselModal: () => void;
  title: string;
};

const CarouselDialog = ({
  children,
  imageIndex,
  totalImageCount,
  toggleCarouselModal,
  title,
}: TCarouselDialogProps) => {
  useRefreshEssentialBanners();

  const handleAfterOpen = () => {
    // change activeElement of the document to use keyboard arrows on gallery carousel
    // https://github.com/leandrowd/react-responsive-carousel/blob/a2738b6931be48ab078661813d4c7979929da57c/src/components/Carousel.tsx#L356
    const rootElement = document.querySelector(`.${Classes.dialogContent} .carousel-root`) as HTMLElement;
    if (rootElement) {
      rootElement.focus();
    }
  };

  return (
    <BasicModal
      isOpen
      onClose={toggleCarouselModal}
      title={title}
      className={Classes.dialog}
      contentClassName={Classes.modalContent}
      size="full"
      onAfterOpen={handleAfterOpen}
    >
      <div className={Classes.dialogContent}>
        {children}
        <div className={`${Classes.carouselIndexContainer} ${Classes.carouselIndexContainerForModal}`}>
          {totalImageCount > 1 ? (
            <span className={Classes.carouselIndex}>
              {imageIndex}/{totalImageCount}
            </span>
          ) : (
            <Trans className={Classes.carouselIndex} i18nKey="gallery.image" count={imageIndex} tagName="span" />
          )}
        </div>
      </div>

      <Banners position={BANNER_POSITION.DYNAMIC.IMAGE} />
    </BasicModal>
  );
};

export default CarouselDialog;
